<template>
	<div
		style="width: 95%"
		class="ml-5"
	>
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<b-modal
			id="template-modal"
			ref="template-modal"
			hide-footer
		>
			<template #modal-title>
				Create New Template
			</template>
			<div class="d-block text-center">
				<b-form-group
					class="form-group"
					label="Name: "
					label-for="block-form1-name"
				>
					<b-form-input
						v-model="addTemplateData.name"
						type="text"
					/>
				</b-form-group>
			</div>
			<b-button
				class="mt-3"
				block
				@click="addTemplate()"
			>
				Save
			</b-button>
		</b-modal>
		<b-modal
			id="import-modal"
			ref="import-modal"
			hide-footer
		>
			<template #modal-title>
				Import Template
			</template>
			<div class="d-block text-center">
				<b-form-group
					label-for="thumbnail"
					label-cols-lg="4"
				>
					<custom-file-input
						id="thumbnail"
						ref="fileimport"
						:placeholder="placeHolders.icon"
						@click.prevent="uploadFile"
					/>
				</b-form-group>
			</div>
		</b-modal>
		<base-block
			title="Existing Template Categories"
			header-bg
		>
			<b-row class="d-flex flex-column justify-content-left">
				<b-col
					sm="5"
					md="9"
					class="my-1"
				>
					<b-button
						class="mt-3"
						:disabled="selectedRows.length == 0"
						@click="table.deselectRow()"
					>
						Deselect all
					</b-button>
					<b-button
						class="mt-3"
						:disabled="selectedRows.length == 0"
						@click="exportSelected()"
					>
						Export Selected
					</b-button>
					<b-button
						class="mt-3"
						@click="exportAll()"
					>
						Export all
					</b-button>
				</b-col>
			</b-row>
			<div
				ref="templateTable"
			/>
		</base-block>
	</div>
</template>
